<template>
  <label :class="[size, { error: formField.hasError.value }]">
    <slot></slot>
  </label>
</template>

<script setup lang="ts">
import { inject, ref } from 'vue';

import { FORM_FIELD_TOKEN } from './form-field/form-field.token';

withDefaults(
  defineProps<{
    size?: 'small' | 'medium' | 'large';
  }>(),
  {
    size: 'medium',
  },
);

const formField = inject(FORM_FIELD_TOKEN, {
  hasError: ref(false),
});
</script>

<style scoped lang="scss">
label {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  vertical-align: top;
  gap: var(--t-spacing-md);
  flex-grow: 1;
  color: var(--t-color-neutral-900);

  &.small {
    font: var(--t-typography-label-sm-font);
  }

  &.medium {
    font: var(--t-typography-label-md-font);
  }

  &.large {
    font: var(--t-typography-label-lg-font);
  }

  &.error {
    color: var(--t-color-red-400);
  }
}
</style>
